export const successMessages: Record<string, string> = {
  EmailContributors: 'Contributor report emailed.',
  GenerateOrganizationAuditReport: 'Organization Audit report emailed.',
  GenerateOrganizationSecurityReport: 'Organization Security report emailed.',
  GenerateCSVExport: 'Global Issue CSV Export report emailed.',
  GenerateRevisionReport: 'Report emailed',
  ExportIssueSnapshots: 'Issue Overview export report emailed.',
  GeneratePackageIndexExport: 'Package Inventory export report emailed.',
  GenerateOrganizationBomReportTwo: 'Global Package Report Bundle report emailed.',
};

export const failureMessages: Record<string, string> = {
  EmailContributors: 'Contributor report failed.',
  GenerateOrganizationAuditReport: 'Global Audit report failed.',
  GenerateOrganizationSecurityReport: 'Global Security report failed.',
  GenerateCSVExport: 'Global Issue CSV Export report failed.',
  GenerateRevisionReport: 'Building report failed.',
  ExportIssueSnapshots: 'Issue Overview export report failed.',
  GeneratePackageIndexExport: 'Package Inventory export report failed.',
  GenerateOrganizationBomReportTwo: 'Global Package Report Bundle report failed.',
};
